import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IMenu } from 'src/app/shared/models';

@Component({
  selector: 'app-users-fgjs',
  templateUrl: './users-fgjs.component.html',
  styleUrl: './users-fgjs.component.scss'
})
export class UsersFgjsComponent implements OnInit {
  activeIndex = 0;

  constructor(private router: Router) { }


  list: IMenu[] = [
    { title: 'Список', route: 'list' },
    { title: 'Добавить', route: 'add' },
  ];

  ngOnInit() {
    this.router.navigate(['main/users-fgjs/list']);
  }
  selectList(i: number) {
    this.activeIndex = i;
  }
}
